// profile/actions.ts
import { ActionTree } from 'vuex';
import axios from 'axios';
import { ProfileState, ResetState, User } from './types';
import { RootState } from '../types';

export const actions: ActionTree<ProfileState, RootState> = {
    async authenticateUser({ commit }, payload ): Promise<any> {
        const response = await axios.post<any>('api/token', payload).then((res) => {
            const result: User = res && res.data;
            commit('profileLoaded', result);
        }).catch ((error) => {
            commit('profileError');
        });
    },

    async refreshUser({ commit } ): Promise<any> {
        const response = await axios.post<any>('api/refreshtoken').then((res) => {
            const result: User = res && res.data;
            commit('profileLoaded', result);
        }).catch ((error) => {
            commit('profileError');
        });
    },

    async registerUser({ commit }, payload): Promise<any> {
        const response = await axios.post<any>('api/registration', payload).then((res) => {
            const result: User = res && res.data;
            commit('registerComplete', result);
        }).catch((error) => {
            commit('registerError', error.response.data);
        });
    },

    async resetPassword({ commit }, payload): Promise<any> {
        const response = await axios.post<any>('api/forgotpassword', payload).then((res) => {
            const result: ResetState = res && res.data;
            commit('resetComplete', result);
        }).catch((error) => {
            commit('resetError');
        });
    },

    async setNewPw({ commit }, payload): Promise<any> {
        const response = await axios.post<any>('api/setnewpassword', payload).then((res) => {
            const result: ResetState = res && res.data;
            commit('resetComplete', result);
        }).catch((error) => {
            commit('resetError', error.response.data);
        });
    },

    async updateOrgInfo({ commit }, payload ): Promise<any> {
        const response = await axios.put<any>('api/updateorg', payload).then((res) => {
            const result: string = res && res.data;
            commit('setNewOrgInfo', result);
        }).catch ((error) => {
            commit('profileError');
        });
    },

    async updateProfileInfo({ commit }, payload ): Promise<any> {
        const response = await axios.put<any>('api/updateprofile', payload).then((res) => {
            const result: string = res && res.data;
            commit('setNewProfileInfo', result);
        }).catch ((error) => {
            commit('profileError');
        });
    },
};
